import { Navigate, Route } from 'react-router';
import SubNavigationLayout from '../../common/components/SubNavigationLayout';
import ErrorBoundary from '../../common/error/ErrorBoundary';
import ChatSettings from '../messages/ChatSettings';
import Conversations from '../messages/Conversations';
import GroupChats from '../messages/GroupChats';
import SubMenu from '../navigation/SubMenu';

/**
 * Messages feature routes
 * Base path: messages/
 */
export const messageRoutes = (
    <Route
        element={
            <SubNavigationLayout
                subNavigation={
                    <ErrorBoundary key="/submenu/messages">
                        <SubMenu parentId="messages" />
                    </ErrorBoundary>
                }
            />
        }
    >
        <Route index element={<Navigate to="conversations/" replace />} />
        <Route
            path="conversations/:id?"
            element={
                <ErrorBoundary key="messages/conversations">
                    <Conversations />
                </ErrorBoundary>
            }
        />
        <Route
            path="groups/:id?"
            element={
                <ErrorBoundary key="messages/groups">
                    <GroupChats />
                </ErrorBoundary>
            }
        />
        <Route
            path="settings"
            element={
                <ErrorBoundary key="messages/settings">
                    <ChatSettings />
                </ErrorBoundary>
            }
        />
    </Route>
);
